import { Pet, Utils, EventInput, TeamMemberColor } from '@gv/triage-components';

type Events = EventInput[];

const { joinStrings } = Utils.Helpers;

export const generateItems = (clinicHours?: any) => {
  const { Timezone, timezone, schedule, clinichours, availabilities } =
    clinicHours ?? {};
  const useTimezone = timezone ?? Timezone;
  const timezoneOptions = {
    timeZone: useTimezone && useTimezone.time_zone_code,
  };
  const events: Events = [];
  const items: any[] = clinichours ?? schedule ?? availabilities?.rows ?? [];
  items.forEach((item) => {
    const {
      client,
      group_id,
      client_id,
      doctor_id,
      dvm_user_id,
      appointment,
      end: endDates,
      start: startDates,
      time_slots: timeslots,
    } = item;
    if (startDates && endDates) {
      startDates.forEach((start: number[], index: number) => {
        const end = endDates[index];
        const startDate = new Date(Number(start)).toLocaleString(
          'en-US',
          timezoneOptions
        );
        const endDate = new Date(Number(end)).toLocaleString(
          'en-US',
          timezoneOptions
        );
        const extendedProps: Record<string, any> = {
          item,
          timeslots,
          end: endDate,
          endSlot: end,
          start: startDate,
          startSlot: start,
          groupId: group_id,
          isGrouped: !!group_id,
          timezone: useTimezone,
          color: TeamMemberColor.Green,
        };
        if (appointment) {
          extendedProps.chatId = appointment.createdChatId;
        }
        if (client_id) {
          extendedProps.clientId = client_id;
          if (client) {
            extendedProps.client = {
              name: client.name,
              phone: client.phone,
              pets: appointment?.task?.pets?.map((pet: Pet) =>
                joinStrings([pet?.name, pet?.species], ', ')
              ),
            };
          }
        }
        if (doctor_id) {
          extendedProps.docId = doctor_id;
        } else if (dvm_user_id) {
          extendedProps.docId = dvm_user_id;
        }
        const event: EventInput = {
          extendedProps,
          title: item.title,
          id: String(item.id),
        };
        events.push(event);
      });
    }
  });
  return { events, timezone: useTimezone };
};
